<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-danger py-7 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" >
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4" v-if="invite || user">
                  <h2>You have been Invited to ClarityNOW</h2>
                  <small>{{ message }}</small>
                </div>
                <validation-observer v-slot="{handleSubmit}" ref="formValidator" v-if="invite">
                  <b-form role="form" @submit.prevent="handleSubmit(acceptInvitation)">
                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-map-big"
                                placeholder="City"
                                name="City"
                                :rules="{required: true}"
                                v-model="model.city">
                    </base-input>

                    <base-input>
                      <state-select v-model="model.state" :required="true"></state-select>
                    </base-input>

                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-lock-circle-open"
                                placeholder="password"
                                type="password"
                                name="password"
                                :rules="{required: true, min: 6}"
                                v-model="model.password"
                                vid="password">
                    </base-input>

                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-lock-circle-open"
                                placeholder="confirm password"
                                type="password"
                                name="Confirm Password"
                                :rules="{required: true, min: 6}"
                                v-model="model.password_confirmation">
                    </base-input>
                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-hat-3"
                                placeholder="e.g. Company or Team Name"
                                name="Team Name"
                                :rules="{required: true}"
                                v-model="model.team">
                    </base-input>
                    <base-input label-for="team_member" name="Realty Role">
                      <el-select v-model="model.realty_role" placeholder="Select Real Estate Role">
                        <el-option v-for="(role, index) in roles"
                                   :key="index"
                                   :label="role.text"
                                   :value="role.value">
                        </el-option>
                      </el-select>
                    </base-input>
                    <div class="text-center">
                      <base-button type="danger" native-type="submit" class="my-4">Complete Registration</base-button>
                    </div>
                  </b-form>
                </validation-observer>
                <div v-if="user">
                  <div class="text-center">
                    <base-button block type="danger" @click="$router.push({path: '/'})">Login</base-button>
                  </div>
                </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import StateSelect from '@/views/Components/Forms/StateSelect';
import {Select, Option} from 'element-ui';
import errorsMixin from "@/mixins/errors-mixin";

export default {
  mixins: [errorsMixin],
  components: {
    StateSelect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      model: {
        token: this.$route.params.token,
        name: null,
        email: null,
        city: null,
        state: null,
        realty_role: null,
        team: null,
        password: null,
        password_confirmation: null
      },
      roles: [
        {
          value: 'Rainmaker',
          text: 'Rainmaker'
        },
        {
          value: 'Solo Agent',
          text: 'Solo Agent'
        },
        {
          value: 'Listing Agent',
          text: 'Listing Agent'
        },
        {
          value: 'Buyers Agent',
          text: 'Buyers Agent'
        },
        {
          value: 'Admin',
          text: 'Admin'
        },
        {
          value: 'ISA',
          text: 'ISA'
        },
        {
          value: 'Real Estate Coach',
          text: 'Real Estate Coach'
        },
        {
          value: 'Other',
          text: 'Other'
        },
      ],
      invite: null,
      user: null,
      message: null,
    }
  },
  computed: {
    authenticated() {
      return this.$store.getters['isAuthenticated'];
    }
  },
  methods: {
    getInvitation() {
      axios.get(process.env.VUE_APP_API_BASE_URL + "/invitation/" + this.$route.params.token)
      .then(response => {
        if(response.data.invite) {
          this.model.name = response.data.invite.name;
          this.model.email = response.data.invite.email;
        }
        this.invite = response.data.invite;
        this.user = response.data.user;
        this.message = response.data.message;
      })
      .catch(error => {
        swal.fire({
          title: `Invalid Invitation`,
          text: 'This invitation code is either invalid or has already been accepted. Login to continue.',
          showConfirmButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Login',
          icon: 'error'
        }).then(result => {
          if(result.isConfirmed) {
            this.$router.push({
              path: '/'
            });
          }
        });
      });
    },
    acceptInvitation() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/invitation", this.model)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Welcome to ClarityNOW!',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          if(this.authenticated) {
            this.$store.dispatch("profile/user");
            this.$store.dispatch("roles/get");
          }

          this.$router.push({
            path: '/home'
          });
        });
      })
      .catch(error => {
        swal.fire({
          title: `Error`,
          text: 'There was an error accepting this invitation. Please reach out to your Rainmaker to move forward.',
          showConfirmButton: false,
          timer: 1750,
          icon: 'warning'
        });
      });
    }
  },
  created() {
    this.getInvitation();
  }
};
</script>